<template>
  <u-deploy-panel>
    <template slot="title">
      {{ $t('title') }}
    </template>
    <template slot="content">
      <p>{{ $t('content') }}</p>
      <ul>
        <li>{{ $t('point1') }}</li>
        <li>{{ $t('point2') }}</li>
        <li>{{ $t('point3') }}</li>
      </ul>
      <p class="my-5 text-center"><img src="../assets/deploy.svg" /></p>
    </template>
    <template slot="actions">
      <a :href="docs" target="_blank">{{ $t('wizard.more') }}</a>
      <v-spacer></v-spacer>
      <v-btn text @click="$emit('cancel')">{{ $t('wizard.cancel') }}</v-btn>
      <v-btn v-if="newDeployment" text @click="$emit('prev')">{{ $t('wizard.prev') }}</v-btn>
      <v-btn color="primary" @click="$emit('next')">{{ $t('wizard.start') }}</v-btn>
    </template>
  </u-deploy-panel>
</template>

<script>
import DeployPanelComponent from '@/components/deploy/Panel.vue'
import { docsUrl } from '@/services/docs'

export default {
  data () {
    return {
      docs: docsUrl('manage')
    }
  },
  props: {
    newDeployment: false
  },
  components: {
    'u-deploy-panel': DeployPanelComponent
  }
}

</script>

<i18n>
{
  "en": {
    "title": "Deploy Unryo",
    "content": "This wizard will help you deploy Unryo on your infrastructure using one of the following methods:",
    "point1": "Docker Compose on a Linux server",
    "point2": "VMware vApp on vSphere",
    "point3": "Kubernetes using a Helm chart"
  }
}
</i18n>
